import cn from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { block } from '../../utils';
import { trackSizeSelector } from './selectors';

export type TimelineRowProps = React.HTMLAttributes<HTMLDivElement> & {
  /**
   * TODO SPAR-26398: this "timeline row" should be renamed to convey that it is
   * for aligning timeline tracks rather than a generic row component.  with the
   * current name, it seems odd to accept `trackId`.
   */
  trackId: string;
};

const TimelineRow = React.forwardRef<HTMLDivElement, TimelineRowProps>(
  ({ className, trackId, ...props }, ref) => {
    const trackSize = useSelector(trackSizeSelector(trackId));

    return (
      <div
        className={cn(block('row', { [trackSize]: true }), className)}
        ref={ref}
        {...props}
      />
    );
  },
);

export default TimelineRow;
